import React, { SetStateAction, useMemo, useState } from "react"
import { Button, Col, Flex, Form, Grid, Input, InputNumber, Popconfirm, Row, Select, Tag, Typography } from "antd";

import { useForm } from "antd/es/form/Form";
import { EditOutlined } from "@ant-design/icons";
import { TypeFormaDePagamentoDaViagem } from "../../../../../Models/Domain/Viagem/FormaDePagamentoDaViagem";
import { ResponsiveAntdTable } from "../../../../../Components/ResponsiveAntdTable";
import { Conjunto } from "../../../../../Components/Conjunto";
import { Ordenar } from "../../../../../Utils/Ordenacao";
import { Formatacoes } from "../../../../../Utils/Formatacao";
import { EnumMeiosDePagamento } from "../../../../../Models/Domain/FInanceiro/Enums";
import InputRangePicker from "@/Components/Base/Input/InputRangePicker";
import Utilitario from "@/Utils/Utilitario";
import { ContaProvedorConciliacaoDicionario } from "@/Models/Financeiro/Conta";
import ProvedorPgtoSelect from "@/Components/Populados/Viagem/Financeiro/ProvedorPgto/ProvedorPgtoSelect";

interface IFormularioDePagamentos {
    formasDePagamentoAPI: [ TypeFormaDePagamentoDaViagem[], React.Dispatch<SetStateAction<TypeFormaDePagamentoDaViagem[]>> ],
    permitirEdicao?: boolean,
}

export const FormularioDePagamentos: React.FC<IFormularioDePagamentos> = (props) => {

    const tamanhoDaTela = Grid.useBreakpoint();

    const [formasDePagamento, setFormasDePagamento] = props.formasDePagamentoAPI;
    const [ form ] = useForm<TypeFormaDePagamentoDaViagem>()

    const [IDDoItemEmEdicao, setIDDoItemEmEdicao] = useState<number | null>()
    const [IDDeAdicao, setIDDeAdicao] = useState<number>(-1)
    
    const estaEditando = useMemo(() => { return IDDoItemEmEdicao != null; }, [IDDoItemEmEdicao])

    const onFinish = (valores: TypeFormaDePagamentoDaViagem) => {
        valores.ativo = true;
        valores.dataInicial = valores.intervalo?.[0];
        valores.dataFinal = valores.intervalo?.[1];

        if (estaEditando) {
            valores.codigo = IDDoItemEmEdicao!;
            setFormasDePagamento((prev) => prev.map((t) => t.codigo == IDDoItemEmEdicao ? valores : t))
            setIDDoItemEmEdicao(null);
        } else {
            valores.codigo = IDDeAdicao;
            setIDDeAdicao(IDDeAdicao - 1)
            setFormasDePagamento((prev) => [...prev, valores])
        }

        form.resetFields();
    }

    return <React.Fragment>

        <Flex vertical style={{width: '100%'}}>

            {IDDoItemEmEdicao != null &&
                <Row gutter={16}>
                    <Col xs={24}>
                        {(() => {
                            const it = formasDePagamento.find((v) => v.codigo == IDDoItemEmEdicao)
                            if (it == null) return;
                            return <Typography.Paragraph>
                                <Tag color='geekblue-inverse'> <EditOutlined /> {it.descricao} </Tag>
                            </Typography.Paragraph>
                        })()}
                    </Col>
                </Row>
            }

            <Form form={form} onFinish={onFinish} autoComplete="off" layout="vertical" validateTrigger="onBlur">
                <Row gutter={16}>
                    <Col xs={24} md={24} lg={8}>
                        <Form.Item<TypeFormaDePagamentoDaViagem> name="descricao" label="Descrição"
                            rules={[{ required: true, message: 'Por favor, informe a descrição!' }]}
                        >
                            <Input id="descricao-pagamento" placeholder="Informe a descrição" />
                        </Form.Item>
                    </Col>

                    {/* <Col xs={24} md={24} lg={4}>
                        <Form.Item<TypeFormaDePagamentoDaViagem> name={["meioDePagamento", "codigo"]} label="Meio"
                            rules={[{ required: true, message: 'Por favor, informe o meio de pagamento!' }]}
                        >
                            <Select
                                allowClear
                                placeholder={"Selecione"}
                                options={[
                                    {
                                        value: EnumMeiosDePagamento.CREDITO,
                                        label: "Crédito"
                                    }
                                ]}
                            />

                        </Form.Item>
                    </Col> */}

                    <Col xs={24} sm={12} md={12} lg={6} xl={4} xxl={4}>
                        <Form.Item<TypeFormaDePagamentoDaViagem> label="Provedor Pgto." name={"codProvedorPagamento"} rules={[ {required : true} ]}>
                            <ProvedorPgtoSelect />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={6}>
                        <Form.Item<TypeFormaDePagamentoDaViagem> label="Intervalo" name={"intervalo"} rules={[ {required : true} ]}>
                            <InputRangePicker />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={6} lg={5} xl={3} xxl={3}>
                        <Form.Item<TypeFormaDePagamentoDaViagem> name={["valorTotal"]} label='Valor total'
                            rules={[
                                { required: true, message: 'Por favor, informe o valor total!' },
                                {
                                    validator: (_, value) => {
                                        if (value == undefined) return Promise.resolve();
                                        return value > 0 ? Promise.resolve() : Promise.reject("O número de alunos tem que ser maior que 0")
                                    }
                                }
                            ]}
                        >
                            <InputNumber addonBefore={<>R$</>} style={{ width: "100%" }} min={0} precision={2} controls={false} placeholder="Informe o valor" />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={6} lg={5} xl={3} xxl={3}>
                        <Form.Item<TypeFormaDePagamentoDaViagem> name={["parcelas"]} label='Parcelas'
                            rules={[
                                { required: true, message: 'Por favor, informe a quantidade de parcelas' },
                                {
                                    validator: (_, value) => {
                                        if (value == undefined) return Promise.resolve();
                                        return value > 0 ? Promise.resolve() : Promise.reject("O número de parcelas tem que ser maior que 0")
                                    }
                                }
                            ]}
                        >
                            <InputNumber style={{ width: "100%" }} min={0} precision={0} controls={false} placeholder="Informe o número de parcelas" />
                        </Form.Item>
                    </Col>

                    <Col xs={24} md={8} lg={2} style={{ display: "flex", gap: "16px", width: "100%" }}>
                        <Form.Item label={tamanhoDaTela.md? <></> : undefined}>
                            <Button type="primary" key="submit" htmlType='submit' style={{ flex: 1 }}>
                                {estaEditando ? "Salvar" : "Adicionar"}
                            </Button>
                        </Form.Item>

                        {estaEditando &&
                            <Form.Item label={<></>}>
                                <Button type="default" danger style={{ flex: 1 }}
                                    onClick={() => {
                                        setIDDoItemEmEdicao(null);
                                        form.resetFields();
                                    }}
                                >
                                    Cancelar
                                </Button>
                            </Form.Item>
                        }
                    </Col>
                    
                </Row>

            </Form>

            <Row style={{marginTop: "8px"}}>
                <Col xs={24}>
                    <ResponsiveAntdTable<TypeFormaDePagamentoDaViagem>
                        bordered
                        locale={{ emptyText: 'Nenhuma forma de pagamento adicionada' }}
                        dataSource={formasDePagamento.filter((e) => e.ativo === true).sort((p, s) => p.dataInicial - s.dataInicial)}
                        rowKey={(k) => k.codigo!}

                        showHeader={true}
                        disableResponsiveness={true}
                        minColWidthIfResponsivenessDisabled={"80px"}
                        scroll={{
                            x : undefined,
                            y : "70vh"
                        }}
                        // style={{
                        //     transform : "rotateX(180deg)",
                        //     direction : "ltr"
                        // }}
                        // pagination={{
                        //     position: ["bottomRight", "topRight"]
                        // }}
                        size="small"
                        tableLayout="auto"
                        columns={[
                            {
                                title: "Provedor",
                                dataIndex: ["codProvedorPagamento"],
                                render: (v) => ContaProvedorConciliacaoDicionario[v],
                                key: "parcelas-provedor",
                            },
                            {
                                title: "Descrição",
                                dataIndex: ["descricao"],
                                key: "descricao-pagamentos", // o css esta vazando
                                sorter: (a, b) => Ordenar.String(a.descricao, b.descricao),
                            },
                            // {
                            //     title: "Meio de pagamento",
                            //     dataIndex: ["meioDePagamento", "codigo"],
                            //     key: "meio-pagamento-pagamento",
                            //     breakpoints: { xs: 12, lg: 4 },
                            //     sorter: (a, b) => Ordenar.Numero(a.meioDePagamento?.codigo, b.meioDePagamento?.codigo),
                            //     render: (v) => {
                            //         if(v == EnumMeiosDePagamento.CREDITO) return "Crédito";

                            //         return "N?A"
                            //     }
                            // },
                            {
                                title: "Intervalo",
                                dataIndex : [],
                                key: "intervalo-pagamento",
                                render: (v) => `${Utilitario.dateToString(typeof v.dataInicial === "string" ? new Date(v.dataInicial) : v.dataInicial)} - ${Utilitario.dateToString(typeof v.dataFinal === "string" ? new Date(v.dataFinal) : v.dataFinal)}`
                            },
                            {
                                title: "Valor total",
                                dataIndex: ["valorTotal"],
                                key: "valor-total-pagamento",
                                sorter: (a, b) => Ordenar.Numero(a.valorTotal, b.valorTotal),
                                render: (v) => Formatacoes.formatarReal(v)
                            },
                            {
                                title: "Parcelas",
                                dataIndex: ["parcelas"],
                                key: "parcelas-pagamento",
                                sorter: (a, b) => Ordenar.Numero(a.parcelas, b.parcelas),
                            },
                            {
                                title: "Ações",
                                key: "acoes-pagamento",
                                noResponsiveTitle: true,
                                render: (_, item) => {
                                    return <Conjunto
                                        itens={(() => {
                                            const editar = (
                                                <Button disabled={estaEditando} type='primary' size='small'
                                                    onClick={() => {
                                                        setIDDoItemEmEdicao(item.codigo)
                                                        form.setFieldsValue(item)
                                                    }}>
                                                    Editar
                                                </Button>
                                            )

                                            const excluir = (
                                                <Popconfirm
                                                    title='Atenção'
                                                    description='Tem certeza que deseja excluir este registro?'
                                                    okText='Confirmar'
                                                    cancelText='Cancelar'
                                                    onConfirm={() => {
                                                        setFormasDePagamento((prev) => prev.map((e) => e.codigo == item.codigo ? { ...e, ativo: false } : e))
                                                    }}
                                                >
                                                    <Button
                                                        disabled={estaEditando}
                                                        type="default"
                                                        danger
                                                        size="small"
                                                    >
                                                        Excluir
                                                    </Button>
                                                </Popconfirm>
                                            )

                                            if (props.permitirEdicao) {
                                                return [editar, excluir];
                                            }

                                            return [excluir];

                                        })()}
                                    />
                                }
                            },
                        ]}

                    />
                </Col>
            </Row>

        </Flex>

    </React.Fragment>

}
